import { useState, useMemo } from "react";

const useSortableData = (data) => {
  const [sortConfig, setSortConfig] = useState({ column: "name", direction: "ascending" });

  const handleSort = (column) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.column === column &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ column, direction });
  };

  const sortedData = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    if (!sortConfig) {
      return data;
    }

    const { column, direction } = sortConfig;

    const sortedArray = [...data].sort((a, b) => {

      let aValue = a.content ? a.content[column] : a[column];
      let bValue = b.content ? b.content[column] : b[column];

      // Si aValue ou bValue sont undefined ou null, les placer à la fin
      if (aValue == null) return direction === "ascending" ? 1 : -1;
      if (bValue == null) return direction === "ascending" ? -1 : 1;

      // Gestion des chaînes de caractères
      if (typeof aValue === "string" && typeof bValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
        return direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      // Gestion des dates (ex : date_input)
      if (column === "date_input" || column === "dateGen") {
        const aDate = new Date(aValue);
        const bDate = new Date(bValue);
        return direction === "ascending" ? aDate - bDate : bDate - aDate;
      }

      // Comparaison des nombres
      if (typeof aValue === "number" && typeof bValue === "number") {
        return direction === "ascending" ? aValue - bValue : bValue - aValue;
      }

      // Comparaison par défaut
      return direction === "ascending"
        ? aValue > bValue
          ? 1
          : -1
        : aValue < bValue
        ? 1
        : -1;
    });

    return sortedArray;
  }, [data, sortConfig]);

  return { sortedData, handleSort, sortConfig };
};

export default useSortableData;
